import { render, staticRenderFns } from "./AmountDetailOrder.vue?vue&type=template&id=fea545ec&scoped=true"
import script from "./AmountDetailOrder.vue?vue&type=script&lang=ts"
export * from "./AmountDetailOrder.vue?vue&type=script&lang=ts"
import style0 from "./AmountDetailOrder.vue?vue&type=style&index=0&id=fea545ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea545ec",
  null
  
)

export default component.exports